import axios from 'axios'
import constants from '@/helpers/constants'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  state: {
    deliveryInfo: null,
    deliveryInfoOurShops: null,
    isDeliveryFormEmpty: false,
    streets: [],
    lastDeliveryInfo: null,
    isFormSubmitted: false,
    isFormHidden: false,
    isMapTabActive: false,
    isAnotherRecipient: false
  },
  getters: {
    selectedSpot (state, getters, rootState) {
      const { deliveryInfo } = rootState.checkout.formData
      if (deliveryInfo && deliveryInfo.deliverySpot) return deliveryInfo.deliverySpot
      return null
    },
    isDeliveryFormValid (state, getters, rootState, rootGetters) {
      const {
        deliveryInfo,
        deliveryType,
        recipientName,
        recipientLastName,
        recipientPhone
      } = rootState.checkout.formData

      if (
        !deliveryInfo ||
        !deliveryType ||
        (rootState.cart.cart.cartStatus === constants.CART_STATUSES.NOT_AVAILABLE && deliveryType && deliveryType.methodId === 1)
      ) {
        return false
      }

      const { invalidFields } = rootState.contactsForm

      if (
        state.isAnotherRecipient &&
        (!recipientName ||
          !recipientLastName ||
          !recipientPhone ||
          invalidFields.recipientName ||
          invalidFields.recipientLastName)
      ) {
        return false
      }

      const { deliverySpot, deliveryTime, house, street } = deliveryInfo
      const { methodId } = deliveryType

      const validMapDelivery = !!((methodId === 1 || methodId === 3 || methodId === 5 || methodId === 7) && deliverySpot)
      const validWarehouseCourierDelivery = !!(methodId === 2 && deliveryTime && house && street)
      const validWarehouseCourierDelivery2 = !!(methodId === 6 && deliveryTime && house && street)
      const validNPCourierDelivery = !!(methodId === 4 && house && street)

      return validMapDelivery || validWarehouseCourierDelivery || validNPCourierDelivery || validWarehouseCourierDelivery2
    }
  },
  mutations: {
    SET_DELIVERY_INFO (state, data) {
      state.deliveryInfo = data
    },
    SET_DELIVERY_INFO_OUR_SHOPS (state, data) {
      state.deliveryInfoOurShops = data
    },
    SET_DELIVERY_FORM_IS_EMPTY (state, bool) {
      state.isDeliveryFormEmpty = bool
    },
    SET_STREETS (state, streets) {
      state.streets = streets
    },
    SET_LAST_DELIVERY_INFO (state, info) {
      state.lastDeliveryInfo = info
    },
    SET_IS_FORM_SUBMITTED (state, bool) {
      state.isFormSubmitted = bool
    },
    SET_IS_FORM_HIDDEN (state, bool) {
      state.isFormHidden = bool
    },
    SET_IS_MAP_TAB_ACTIVE (state, bool) {
      state.isMapTabActive = bool
    },
    SET_IS_ANOTHER_RECIPIENT (state, bool) {
      state.isAnotherRecipient = bool
    }
  },
  actions: {
    FETCH_DELIVERY_INFO ({ commit, rootGetters, dispatch, rootState }, params) {
      GoogleTagManagerService.checkoutEvent({
        analyticsData: rootGetters.cartInfoForEcommerce,
        actionField: { 'step': 3, 'option': `${params.methodId}` },
        params: {
          'event': 'gtm-ee-event-checkout-step-3',
          'gtm-ee-event-action': 'Checkout Step 3'
        }
      })

      dispatch('SET_LOADING_COMPONENT', { deliveryTypeInput: true }, { root: true })
      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/method-details/', { params })
          .then(response => {
            const { deliveryInfo, deliveryType } = rootState.checkout.formData

            // Если выбирается способ доставки почтомат или отделение новой почты,
            // и мы получаем пустой массив доступных почтоматов или ни одного доступного для выдачи отделения.
            // Делаем его disabled и пишем текст ошибки на методе доставки
            if (Array.isArray(response.data.delivery_data) && (response.data.delivery_data.length === 0 || !response.data.delivery_data.find(el => el.is_available !== '0')) && (response.data.slug === 'novaPoshtaParcel' || response.data.slug === 'novaPoshtaWarehouse')) {
              const { translations } = rootGetters
              const { deliveryTypes } = rootState.contactsForm
              let newDeliveryTypes = [...deliveryTypes]
              const methodId = response.data.slug === 'novaPoshtaParcel' ? 7 : 3
              const errorText = response.data.slug === 'novaPoshtaParcel' ? translations('zero_spots_error_text') : translations('zero_spots_error_text_dimension')
              let deliveryItemActual = newDeliveryTypes.find(el => el.methodId === methodId)
              let itemNPBoxIndex = newDeliveryTypes.findIndex(el => el.methodId === methodId)
              deliveryItemActual = { ...deliveryItemActual, status: false, disabledInfo: errorText }
              newDeliveryTypes[itemNPBoxIndex] = deliveryItemActual
              commit('REDUCE_FORM_DATA', {
                deliveryType: {
                  ...deliveryType,
                  status: false,
                  disabledInfo: errorText
                },
                deliveryInfo: null
              })
              dispatch('SET_CONTACTS_FORM_DELIVERY_TYPES', newDeliveryTypes, { root: true })
              commit('SET_IS_FORM_HIDDEN', false)
            }

            if (deliveryInfo && deliveryInfo.deliverySpot) {
              for (let i = 0; i < response.data.delivery_data.length; i++) {
                if (
                  deliveryInfo.deliverySpot.uid === response.data.delivery_data[i].ref &&
                  response.data.delivery_data[i].is_available === '0'
                ) {
                  commit('REDUCE_FORM_DATA', { deliveryInfo: null })
                  commit('SET_IS_FORM_HIDDEN', false)
                }

                if (
                  deliveryInfo.deliverySpot.uid === response.data.delivery_data[i].uid &&
                  response.data.delivery_data[i].hasOwnProperty('cart_status') &&
                  response.data.delivery_data[i].cart_status !== deliveryInfo.deliverySpot.cartStatus
                ) {
                  commit('REDUCE_FORM_DATA', {
                    deliveryInfo: {
                      deliverySpot: {
                        ...deliveryInfo.deliverySpot,
                        cartStatus: response.data.delivery_data[i].cart_status
                      }
                    }
                  })
                  commit('SET_SELECTED_SPOT', {
                    ...rootState.map.selectedSpot,
                    cartStatus: response.data.delivery_data[i].cart_status
                  })
                }
              }
            }

            const dmDelivery = rootState.contactsForm.deliveryTypes.find(type => type.methodId === 1)
            if (
              (response.data.slug === 'novaPoshtaWarehouse' || response.data.slug === 'ukrposhta') &&
              dmDelivery &&
              dmDelivery.status
            ) {
              params.methodId = 1

              axios.get(rootGetters.urlLanguagePrefix + '/shop/checkout/method-details/', { params }).then(res => {
                if (res.data) commit('SET_DELIVERY_INFO_OUR_SHOPS', res.data)
              })
            } else {
              commit('SET_DELIVERY_INFO_OUR_SHOPS', null)
            }

            // записываем флаг для блонирования/разблокирования чекбокса
            commit('SET_IS_DISABLED_CALLBACK_STATUS', !response.data.can_checkout_without_call)

            commit('SET_DELIVERY_INFO', response.data)

            resolve()
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => dispatch('SET_LOADING_COMPONENT', { deliveryTypeInput: false }, { root: true }))
      })
    },
    FETCH_STREETS: (ctx, value) => {
      if (!value) {
        ctx.commit('SET_STREETS', [])
        return
      }
      const params = {
        cityId: ctx.rootState.checkout.formData.city.id,
        cityName: value
      }
      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-streets/', { params })
        .then(response => ctx.commit('SET_STREETS', response.data.streets))
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
    },
    SET_LAST_DELIVERY_INFO_ACTION: ({ commit }, info) => {
      commit('SET_LAST_DELIVERY_INFO', info)

      const { id, flat, house, street } = info
      if (id === 2 || id === 4) {
        commit('REDUCE_FORM_DATA', {
          deliveryInfo: { flat, house, street: { value: street, name: street } }
        })
      }
    },
    SET_IS_FORM_HIDDEN_ACTION ({ commit }, bool) {
      commit('SET_IS_FORM_HIDDEN', bool)
    },
    SET_DELIVERY_FORM_EMPTY_ACTION ({ commit }, bool) {
      commit('SET_DELIVERY_FORM_IS_EMPTY', bool)
    },
    VALIDATE_ANOTHER_RECIPIENT_FORM ({ commit, rootState, rootGetters }) {
      const { formData } = rootState.checkout

      if (!formData.recipientName) {
        commit('SET_INVALID_FIELDS', { recipientName: rootGetters.translations('blank_field_error') })
      }
      if (!formData.recipientLastName) {
        commit('SET_INVALID_FIELDS', { recipientLastName: rootGetters.translations('blank_field_error') })
      }
    },
    SUBMIT_DELIVERY ({ commit, getters, state, dispatch, rootState, rootGetters }) {
      if (!getters.isDeliveryFormValid) {
        commit('SET_DELIVERY_FORM_IS_EMPTY', true)
        dispatch('VALIDATE_ANOTHER_RECIPIENT_FORM')
      } else {
        commit('SET_IS_FORM_HIDDEN', true)
        commit('SET_IS_FORM_SUBMITTED', true)
        if (
          !rootState.checkout.formData.legalPersonInfo ||
          !Object.keys(rootState.checkout.formData.legalPersonInfo).length
        ) {
          dispatch('GET_LEGAL_HISTORY', { root: true })
        }
      }
      if (GoogleEnhancedEcommerce.isEnabled) {
        const value = rootGetters.cartInfoForEcommerce.reduce((acc, curr) => {
          return acc + curr.price * curr.quantity
        }, 0)
        if (rootGetters.cartInfoForEcommerce.length > 0) {
          GoogleEnhancedEcommerce.addShippingInfo({
            value,
            legal_personion: rootGetters.isLegalPerson ? 'yes' : 'no',
            shipping_tier: rootState.checkout.formData?.deliveryType?.title || '',
            another_person: state.isAnotherRecipient ? 'yes' : 'no',
            items: rootGetters.cartInfoForEcommerce.map(el => GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(el))
          })
        }
      }
    },
    SET_IS_MAP_TAB_ACTIVE_ACTION ({ commit }, isActive) {
      commit('SET_IS_MAP_TAB_ACTIVE', isActive)
    },
    SET_IS_ANOTHER_RECIPIENT_ACTION ({ commit }, bool) {
      commit('SET_IS_ANOTHER_RECIPIENT', bool)
    }
  }
}
